import Tile from "./Tile";

const Board = ({ board }) => {
  return (
    <div className="board">
      {board.map((row, r) =>
        row.map((value, c) => (
          <Tile key={`${r}-${c}`} value={value} />
        ))
      )}
    </div>
  );
};

export default Board;
